// Universal-Toggler für "Shop" und "Marken" – blockt Navigation und öffnet Untermenü
document.addEventListener('click', function (e) {
  const a = e.target.closest('a');
  if (!a) return;

  const text = (a.textContent || '').trim().toLowerCase();
  if (text !== 'shop' && text !== 'marken') return;

  // Prüfen, ob es ein Untermenü gibt (verschiedene Theme-Varianten)
  const li = a.closest('li');
  if (!li) return;

  const submenu =
    li.querySelector(':scope > ul, :scope > .header__submenu, :scope > .mega-menu, :scope > .subnav');

  if (!submenu) return; // wenn kein Untermenü vorhanden ist, normal navigieren

  // Seite nicht wechseln
  e.preventDefault();
  e.stopPropagation();

  // Zustandsklasse toggeln
  const isOpen = li.classList.contains('is-open');

  // andere offene schließen (optional)
  li.parentElement?.querySelectorAll(':scope > li.is-open').forEach(x => {
    if (x !== li) x.classList.remove('is-open');
  });

  li.classList.toggle('is-open', !isOpen);
}, false);

// Kleines “Hover öffnet” für Desktop (falls Theme das nicht schon macht)
document.addEventListener('DOMContentLoaded', () => {
  const mqHover = window.matchMedia('(hover:hover)');
  if (!mqHover.matches) return;
  document.querySelectorAll('li').forEach(li => {
    li.addEventListener('mouseenter', () => li.classList.add('is-hover'));
    li.addEventListener('mouseleave', () => li.classList.remove('is-hover'));
  });
});
